const locale = {
	VIEW_ITEM_BUTTON_COMPANIES_MERGE: 'Merge Companies',
	COMPANIES_MERGE_DIALOG_TITLE: 'Merge Companies',
	COMPANIES_MERGE_DIALOG_DESCRIPTION:
		'Transfer ALL the fields of the registry (except the title) and the related elements (People, Activities, Opportunities, etc.) from the Company indicated as the "Replaced Company", which will be blocked with the reason specified in the "Reason" field.',
	COMPANIES_MERGE_DIALOG_FIELD_COMPANY: 'Replaced Company',
	COMPANIES_MERGE_DIALOG_FIELD_REASON: 'Reason',

	COMPANIES_DUPLICATE_ALERT_DIALOG_TITLE: '{count, plural, one {Similar Company} other {# similar Companies}} found',
	COMPANIES_DUPLICATE_ALERT_DIALOG_DESCRIPTION:
		'At least one other Company with the same VAT number has been detected (visible below). It is likely that the Company you are adding is a duplicate of an existing registry. To continue the operation use the "Continue" button at the bottom.',

	// #region Companies fields
	COMPANIES_ERP_CUSTOMER_ID: 'NAV Customer ID: {id}',
	COMPANIES_ERP_SUPPLIER_ID: 'NAV Supplier ID: {id}',
	COMPANIES_ERP_CONTACT_ID: 'NAV Contact ID: {id}',
	COMPANIES_IMPORT_DATE: 'Imported date: {date}',

	DETAILS_COMPANIES_FIELD_TITLE: 'Name',
	DETAILS_COMPANIES_FIELD_ERP_CUSTOMER_ID: 'NAV Customer ID',
	DETAILS_COMPANIES_FIELD_ERP_SUPPLIER_ID: 'NAV Supplier ID',
	DETAILS_COMPANIES_FIELD_ERP_CONTACT_ID: 'NAV Contact ID',
	DETAILS_COMPANIES_FIELD_STATUS: 'Company Status',
	DETAILS_COMPANIES_FIELD_RELATION: 'Company Relation Type',
	DETAILS_COMPANIES_FIELD_TYPE: 'Company Type',
	DETAILS_COMPANIES_FIELD_SUBTYPES: 'Company Subtypes',
	DETAILS_COMPANIES_FIELD_ASSIGNED_USER: 'Internal assigned User',
	DETAILS_COMPANIES_FIELD_ASSIGNED_USER_2: 'External assigned User',
	DETAILS_COMPANIES_FIELD_REFERENCE: 'Company Reference',
	DETAILS_COMPANIES_FIELD_RATING: 'Rating',
	DETAILS_COMPANIES_FIELD_VAT: 'VAT Code',
	DETAILS_COMPANIES_FIELD_TAXCODE: 'Tax Code',
	DETAILS_COMPANIES_FIELD_TAGS: 'Tags',
	DETAILS_COMPANIES_FIELD_WARNING: 'Warning',
	DETAILS_COMPANIES_FIELD_BLOCKED: 'Blocked',
	DETAILS_COMPANIES_FIELD_PEC: 'Certified Email',
	DETAILS_COMPANIES_FIELD_LEGAL_FORM: 'Legal Form',
	DETAILS_COMPANIES_FIELD_ATECO: 'Ateco Code',
	DETAILS_COMPANIES_FIELD_EMPLOYEES: 'Employees number',
	DETAILS_COMPANIES_FIELD_REVENUE: 'Annual revenue',
	DETAILS_COMPANIES_FIELD_ESTABLISHMENT_DATE: 'Establishment Date',
	DETAILS_COMPANIES_FIELD_LANGUAGE: 'Main language',
	DETAILS_COMPANIES_FIELD_DOMAIN: 'Main domain',
	DETAILS_COMPANIES_FIELD_PRICINGGROUP: 'Pricing group',
	DETAILS_COMPANIES_FIELD_DISCOUNTGROUP: 'Discount group',
	DETAILS_COMPANIES_FIELD_PAYMENTTERMS: 'Payment terms',
	DETAILS_COMPANIES_FIELD_PAYMENTMETHOD: 'Payment method',
	DETAILS_COMPANIES_FIELD_SHIPPINGMETHOD: 'Shipping method',
	DETAILS_COMPANIES_FIELD_SHIPPINGAGENT: 'Shipping agent',
	DETAILS_COMPANIES_FIELD_SDI: 'SDI code',
	DETAILS_COMPANIES_FIELD_CREDITLIMIT: 'Credit Limit',
	DETAILS_COMPANIES_FIELD_ADDRESS: 'Address',
	DETAILS_COMPANIES_FIELD_ADDRESS_CITY: 'Address City',
	DETAILS_COMPANIES_FIELD_ADDRESS_ZIP: 'Address Zip',
	DETAILS_COMPANIES_FIELD_ADDRESS_DISTRICT: 'Address District',
	DETAILS_COMPANIES_FIELD_ADDRESS_REGION: 'Address Region',
	DETAILS_COMPANIES_FIELD_ADDRESS_COUNTRY: 'Address Country',
	DETAILS_COMPANIES_FIELD_ADDRESS_ZONE: 'Address Zone',
	DETAILS_COMPANIES_BUSINESS_CARD_SECTION: 'Business Card',
	DETAILS_COMPANIES_BUSINESS_CARD_SUBHEADER: "View or update this Company's business card",
	BUSINESS_CARD_FRONT: 'Front',
	BUSINESS_CARD_BACK: 'Back',
	BUSINESS_CARD_NO_IMAGE: 'No image found',
	DETAILS_COMPANIES_FIELD_MARKETINGACTION: 'Origin Marketing Action',
	DETAILS_COMPANIES_FIELD_COMMERCIALCAMPAIGN: 'Origin Commercial Campaign',
	DETAILS_COMPANIES_FIELD_LEADCHANNEL: 'Lead Channel',
	DETAILS_COMPANIES_FIELD_BROKER_COMPANY: 'Broker Company',
	DETAILS_COMPANIES_FIELD_BROKER_PERSON: 'Broker People',
	DETAILS_COMPANIES_FIELD_PARENT_COMPANY: 'Parent Company',
	DETAILS_COMPANIES_FIELD_D_MODIFIED: 'Edit date', // ORDER_BY
	// #endregion

	// #region Details Address section
	DETAILS_ADDRESS_SECTION: 'Address',
	DETAILS_ADDRESS_SUBHEADER: 'View and edit the address',

	DETAILS_COMPANIES_REFRESH_COORDINATES: 'Recalculate coordinates',
	// #endregion

	// #region Details Address section
	DETAILS_NAV_INFO_SECTION: 'NAV Informations',
	DETAILS_NAV_INFO_SUBHEADER: 'View NAV informations',
	// #endregion

	// #region User Avatar
	COMPANIES_AVATAR_SECTION: 'Avatar',
	COMPANIES_AVATAR_SUBHEADER: "View or update the Company's avatar",
	// #endregion

	// #region Tabs
	TAB_COMPANIES_ALL: 'All',
	TAB_COMPANIES_CUSTOMERS: 'Customers',
	TAB_COMPANIES_SUPPLIERS: 'Suppliers',
	TAB_COMPANIES_OTHERS: 'Others',
	TAB_BUSINESS_CARD: 'Business Cards',
	TAB_DUPLICATES: 'Duplicates',
	// #endregion

	// #region Creditsafe reports
	TAB_COMPANIES_CREDITSAFE: 'Creditsafe reports',

	DETAILS_COMPANIES_CREDITSAFE_SECTION: 'Creditsafe financial reports',
	COMPANIES_CREDITSAFE_LAST_UPDATE: 'Last update: {date}',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_DESCRIPTION_NOTLINKED:
		'In order to download the financial reports, connect the Company to a Credisafe registry using the "Connect" button.',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_DESCRIPTION_LINKED:
		'The Company is correctly connected to the Creditsafe registry. It is possible to download the financial reports using the "Download report" button or change the connected registry using the "Change link" button.',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_DESCRIPTION_WARNING:
		'ATTENTION: the country and the VAT number of the Company are required to carry out the search.',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_TITLE: 'Report format',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_ORDINARY: 'Ordinary',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_ABBREVIATED: 'Abbreviated',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_CONSOLIDATED: 'Consolidated',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_MICRO: 'Micro',

	COMPANIES_CREDITSAFE_BUTTON_LINK: 'Link',
	COMPANIES_CREDITSAFE_BUTTON_RELINK: 'Change link',
	CREDITSAFE_DIALOG_SEARCH_TITLE: 'Choose the Creditsafe registry to link',
	CREDITSAFE_DIALOG_SEARCH_ERROR:
		'The country and the VAT number of the Company are required to carry out the search!',

	COMPANIES_CREDITSAFE_BUTTON_DOWNLOAD: 'Download report',
	CREDITSAFE_DIALOG_DOWNLOAD_TITLE: 'How do you want to download the Creditsafe report?',
	CREDITSAFE_DIALOG_DOWNLOAD_DESCRIPTION:
		'Using the "Creditsafe" option the report will be downloaded directly from the Creditsafe database, consuming 1 credit. Instead, by selecting the "Local Server" option, the data already present in the Perceptive database will be imported, without using credits.',
	CREDITSAFE_DIALOG_DOWNLOAD_OPTION_CREDITSAFE: 'Creditsafe',
	CREDITSAFE_DIALOG_DOWNLOAD_OPTION_LOCAL: 'Local server',
	CREDITSAFE_DIALOG_UPDATE_COMPANY_TITLE: 'Do you also want to update the following Company fields?',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_INCOME_STATEMENT: 'INCOME STATEMENT',
	CSFS_TOTALVALUEOFPRODUCTION: 'Total value of production',
	CSFS_OPERATINGREVENUES: 'Operating revenues',
	CSFS_CHANGEINWORKINPROGRESS: 'Change in work progress',
	CSFS_TOTALOTHERINCOMEANDREVENUES: 'Total other income and revenues',
	CSFS_TOTALCOSTOFPRODUCTION: 'Total cost of production',
	CSFS_PURCHASEOFGOODS: 'Purchase of goods',
	CSFS_COSTOFSERVICES: 'Services',
	CSFS_USEOFTHIRDPARTYASSETS: 'Use of third party assets',
	CSFS_TOTALPAYROLLANDRELATEDCOSTS: 'Total payroll and related costs',
	CSFS_CHANGESININVENTORIES: 'Change in inventories',
	CSFS_OTHEROPERATINGEXPENSES: 'Other operating expenses',
	CSFS_TOTALAMORTISATIONDEPRECIATIONANDWRITEDOWNS: 'Total amortisation, depreciation and write-downs',
	CSFS_EBITDA: 'EBITDA',
	CSFS_EBIT: 'EBIT',
	CSFS_TOTALFINANCIALINCOMEANDEXPENSE: 'Total financial income and expense',
	CSFS_TOTALVALUEADJUSTMENTSTOFINANCIALASSETSANDLIABILITIES:
		'Total value adjustments to financial assets and liabilities',
	CSFS_PRETAXRESULT: 'Pre-tax result',
	CSFS_TOTALTAXESONTHEINCOMEFORTHEYEAR: 'Total taxes on the income of the year',
	CSFS_PROFITORLOSSFORTHEYEAR: 'Profit (loss) for the year',
	CSFS_CASHFLOWPL: 'Cash flow',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_GROWTH_RATIOS: 'GROWTH RATIOS',
	CSFS_CHANGEINREVENUESPERCENTAGE: 'Chage in revenues',
	CSFS_CHANGEINTOTALVALUEOFPRODUCTIONPERCENTAGE: 'Change in total value of production',
	CSFS_CHANGEINTOTALASSETSPERCENTAGE: 'Change in total assets',
	CSFS_CHANGEINSHAREHOLDERSEQUITYPERCENTAGE: 'Change in shreholders equity',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_PROFITABILITY_RATIOS: 'PROFITABILITY RATIOS',
	CSFS_RETURNONSALESPERCENTAGE: 'R.O.S. (Return on sales)',
	CSFS_RETURNONINVESTMENTPERCENTAGE: 'R.O.I. (Return on investment)',
	CSFS_RETURNONEQUITYPERCENTAGE: 'R.O.E. (Return on equity)',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_LIQUIDITY_RATIOS: 'LIQUIDITY RATIOS',
	CSFS_CURRENTRATIO: 'Current ratio',
	CSFS_ACIDTEST: 'Acid test',
	CSFS_DEBTORDAYS: 'Debtor days',
	CSFS_CREDITORDAYS: 'Creditor days',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_BALANCE_SHEET_ASSETS: 'BALANCE SHEET: ASSETS',
	CSFS_RECEIVABLESDUEFROMSHAREHOLDERS: 'Receivables due from shareholders',
	CSFS_INTANGIBLEFIXEDASSETS: 'Intangible fixed assets',
	CSFS_TANGIBLEFIXEDASSETS: 'Tangible fixed assets',
	CSFS_FINANCIALFIXEDASSETS: 'Financial fixed assets',
	CSFS_TOTALFIXEDASSETS: 'Total fixed assets',
	CSFS_TOTALINVENTORIES: 'Total inventories',
	CSFS_TOTALRECEIVABLES: 'Total receivables',
	CSFS_DEBTORSDUEWITHIN1YEAR: 'due within the following year',
	CSFS_DUEFROMSUPPLIERSWITHIN1YEAR: 'due to suppliers within the following year',
	CSFS_PREPAIDTAX: 'prepaid tax',
	CSFS_CURRENTFINANCIALASSETS: 'Current financial assets',
	CSFS_LIQUIDASSETS: 'Liquid assets',
	CSFS_TOTALCURRENTASSETS: 'Total current assets',
	CSFS_ACCRUEDINCOMEANDPREPAYMENTS: 'Accrued income and prepayments',
	CSFS_TOTALASSETS: 'Total assets',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_BALANCE_SHEET_LIABILITIES: 'BALANCE SHEET: LIABILITIES',
	CSFS_SHAREHOLDERSEQUITY: 'Shareholders equity',
	CSFS_SHARECAPITAL: 'Share capital',
	CSFS_OTHERRESERVES: 'Other reserves',
	CSFS_NETPROFITORLOSSFORTHEYEAR: 'Profit (loss) for the year',
	CSFS_PROVISIONFORRISKSANDCHARGES: 'Provision for risks and charges',
	CSFS_PROVISIONFORSEVERANCEINDEMNITY: 'Provision for severance indemnity (TFR)',
	CSFS_TOTALPAYABLES: 'Total payables',
	CSFS_DUEWITHIN1YEAR: 'Due within the following year',
	CSFS_DUETOSUPPLIERSWITHIN1YEAR: 'due to suppliers within the following year',
	CSFS_DUETOBANKWITHIN1YEAR: 'due to bank within the following year',
	CSFS_DUEAFTER1YEAR: 'Due beyond the following year',
	CSFS_DUETOSUPPLIERSAFTER1YEAR: 'due to suppliers beyond the following year',
	CSFS_DUETOBANKAFTER1YEAR: 'due to bank beyond the following year',
	CSFS_OTHERPAYABLES: 'Other payables',
	CSFS_ACCRUEDEXPENSESANDPREPAYMENTS: 'Accrued income and prepayments',
	CSFS_TOTALLIABILITIES: 'Total liabilities and equity',
	// #endregion

	// #region Atoka reports
	TAB_COMPANIES_ATOKA: 'Atoka reports',

	DETAILS_COMPANIES_ATOKA_SECTION: 'Atoka financial reports',
	COMPANIES_ATOKA_LAST_UPDATE: 'Last update: {date}',
	DETAILS_COMPANIES_ATOKA_SECTION_DESCRIPTION_NOTLINKED:
		'In order to download the financial reports, connect the Company to a Credisafe registry using the "Connect" button.',
	DETAILS_COMPANIES_ATOKA_SECTION_DESCRIPTION_LINKED:
		'The Company is correctly connected to the Atoka registry. It is possible to download the financial reports using the "Download report" button or change the connected registry using the "Change link" button.',
	DETAILS_COMPANIES_ATOKA_SECTION_DESCRIPTION_WARNING:
		'ATTENTION: the VAT number of the Company is required to carry out the search.',

	COMPANIES_ATOKA_BUTTON_LINK: 'Link',
	COMPANIES_ATOKA_BUTTON_RELINK: 'Change link',
	ATOKA_DIALOG_SEARCH_TITLE: 'Choose the Atoka registry to link',
	ATOKA_DIALOG_SEARCH_ERROR: 'The country and the VAT number of the Company are required to carry out the search!',

	COMPANIES_ATOKA_BUTTON_DOWNLOAD: 'Download report',
	ATOKA_DIALOG_DOWNLOAD_TITLE: 'How do you want to download the Atoka report?',
	ATOKA_DIALOG_DOWNLOAD_DESCRIPTION:
		'Using the "ATOKA" option the report will be downloaded directly from the Atoka database, consuming 1 credit. Instead, by selecting the "Local Server" option, the data already present in the Perceptive database will be imported, without using credits.',
	ATOKA_DIALOG_DOWNLOAD_OPTION_ATOKA: 'Atoka',
	ATOKA_DIALOG_DOWNLOAD_OPTION_ATOKA_INFO: 'Cloud service',
	ATOKA_DIALOG_DOWNLOAD_OPTION_LOCAL: 'Local server',
	ATOKA_DIALOG_UPDATE_COMPANY_TITLE: 'Do you also want to update the following Company fields?',

	DETAILS_COMPANIES_ATOKA_SECTION_INCOME_STATEMENT: 'INCOME STATEMENT',
	ATFS_PRODUCTION: 'Production value',
	ATFS_REVENUE: 'Net revenues',
	ATFS_COSTS: 'Expenses',
	ATFS_PURCHASES: 'Net purchases',
	ATFS_SERVICESANDTPGOODSCHARGES: 'Services and third-party goods charges',
	ATFS_STAFFCOSTS: 'Labor costs',
	ATFS_RAWMATERIALSVARIATION: 'Raw materials variation',
	ATFS_MOL: 'Gross operating margin',
	ATFS_PROFIT: 'Profit',
	ATFS_EBITDA: 'EBITDA',
	ATFS_ASSETS: 'Assets',
	ATFS_CAPITALSTOCK: 'Capital stock',
	ATFS_EQUITY: 'Equity',
	ATFS_NETWORKINGCAPITAL: 'Networking capital',
	ATFS_NETFINANCIALPOSITION: 'Net financial position',
	// #endregion

	// #region Order notes
	DETAILS_HEADER_BUTTON_COMPANIES_ORDERS_NOTES: 'Order Proposals notes',
	DIALOG_COMPANIES_ORDERS_NOTES_EDIT: 'Edit the Order Proposals notes'
	// #endregion
};

export default locale;
